module.exports = __webpack_public_path__ + "static/media/money.5fc6e20f.png";


//////////////////
// WEBPACK FOOTER
// ./src/milestone/money.png
// module id = 2097
// module chunks = 0